// @ts-nocheck
// Shown instead of chapter 2-12 content when the reader doesn't have access.
// Two states:
//   1. Not signed in           -> "Sign in / sign up" CTA  (auth modal)
//   2. Signed in, not paid     -> "Buy access ₪89" CTA     (Lemon Squeezy)
// Once the user has an active license the PaywallGate isn't rendered at all.

import { useState, useEffect } from "react";
import { AuthModal } from "./AuthModal";
import { useAuth } from "../lib/useAuth";
import { supabase } from "../lib/supabase";
import { buildCheckoutUrl, openLemonCheckout, LEMON_VARIANT_ID } from "../lib/lemonConfig";
import { trackInitiateCheckout, trackLead } from "../lib/fbTrack";

const styles = `
.paywall-wrap { padding: 8px 4px 60px; direction: rtl; }
.paywall-card { background: linear-gradient(135deg, #FFF8F0 0%, #FFFDF9 100%); border: 1px solid #E8DCC8; border-radius: 24px; padding: 40px 32px; text-align: center; box-shadow: 0 12px 48px rgba(92,61,46,0.10); position: relative; overflow: hidden; }
.paywall-card::before { content: ''; position: absolute; top: -80px; right: -80px; width: 240px; height: 240px; border-radius: 50%; background: rgba(212,135,90,0.08); }
.paywall-icon { font-size: 42px; margin-bottom: 12px; position: relative; }
.paywall-hero { width: 210px; height: 158px; object-fit: cover; border-radius: 18px; margin-bottom: 14px; border: 3px solid rgba(212,135,90,0.35); box-shadow: 0 6px 20px rgba(92,61,46,0.18); position: relative; background: #FFFDF9; }
/* The heart artwork is square - a landscape crop would clip its arcs. */
.paywall-hero-square { width: 185px; height: 185px; }
.paywall-hero-sm { width: 140px; height: 140px; margin-bottom: 10px; }
.paywall-pay { display: block; width: 100%; max-width: 420px; margin: 6px auto 0; background: linear-gradient(135deg, #A0704A, #D4875A); color: #fff; border-radius: 16px; padding: 16px 24px; font-family: 'Heebo', sans-serif; font-size: 18px; font-weight: 700; text-decoration: none; text-align: center; box-shadow: 0 6px 20px rgba(160,112,74,0.35); transition: transform .15s; position: relative; }
.paywall-pay:hover { transform: translateY(-2px); }
.paywall-pay-note { font-size: 12.5px; color: #8B7355; margin: 10px auto 0; max-width: 400px; line-height: 1.6; position: relative; }
.paywall-consent-line { font-size: 11.5px; color: #8B7355; margin: 10px auto 0; max-width: 420px; line-height: 1.6; position: relative; }
.paywall-consent-line a { color: #A0704A; text-decoration: underline; }
.paywall-survey { max-width: 420px; margin: 22px auto 0; padding: 16px 18px; background: rgba(255,255,255,0.75); border: 1px solid rgba(196,168,130,0.4); border-radius: 14px; position: relative; text-align: right; }
.paywall-survey-q { font-size: 14.5px; font-weight: 700; color: #5C3D2E; margin-bottom: 10px; }
.paywall-survey-row { display: flex; flex-wrap: wrap; gap: 8px; }
.paywall-survey-opt { background: #fff; border: 1px solid rgba(160,112,74,0.45); color: #5C3D2E; border-radius: 20px; padding: 8px 14px; font-family: 'Heebo', sans-serif; font-size: 13.5px; cursor: pointer; transition: background .15s; }
.paywall-survey-opt:hover { background: rgba(160,112,74,0.08); }
.paywall-survey-thanks { font-size: 13.5px; color: #2E7D32; margin-bottom: 8px; }
.paywall-survey-input { width: 100%; border: 1px solid #D9C8B0; border-radius: 10px; padding: 9px 12px; font-family: 'Heebo', sans-serif; font-size: 13.5px; color: #2D1B10; background: #fff; resize: vertical; }
.paywall-survey-send { margin-top: 8px; background: transparent; color: #A0704A; border: 1px solid rgba(160,112,74,0.4); border-radius: 12px; padding: 7px 16px; font-family: 'Heebo', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; }
.paywall-survey-send:hover { background: rgba(160,112,74,0.08); }
.paywall-chip { display: inline-block; background: rgba(160,112,74,0.12); color: #5C3D2E; padding: 5px 14px; border-radius: 14px; font-size: 12px; font-weight: 600; margin-bottom: 14px; letter-spacing: 1px; position: relative; }
.paywall-title { font-family: 'Frank Ruhl Libre', serif; font-size: 28px; font-weight: 700; color: #5C3D2E; margin-bottom: 14px; line-height: 1.3; position: relative; }
.paywall-lead { font-size: 16px; line-height: 1.7; color: #5C3D2E; max-width: 460px; margin: 0 auto 28px; position: relative; }
.paywall-cta { background: linear-gradient(135deg, #A0704A, #D4875A); color: white; border: none; padding: 14px 32px; border-radius: 16px; font-family: 'Heebo', sans-serif; font-size: 16px; font-weight: 600; cursor: pointer; box-shadow: 0 6px 20px rgba(160,112,74,0.35); transition: transform .15s; position: relative; }
.paywall-cta:hover { transform: translateY(-2px); }
.paywall-cta:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
.paywall-cta-secondary { background: transparent; color: #A0704A; border: 1px solid rgba(160,112,74,0.4); padding: 11px 24px; border-radius: 14px; font-family: 'Heebo', sans-serif; font-size: 14px; font-weight: 500; cursor: pointer; margin-top: 12px; transition: background .15s; position: relative; }
.paywall-cta-secondary:hover { background: rgba(160,112,74,0.08); }
.paywall-slim-head { margin: 0 0 16px; position: relative; }
.paywall-slim-price { font-family: 'Frank Ruhl Libre', serif; font-size: 20px; font-weight: 800; color: #5C3D2E; }
.paywall-slim-price strong { font-size: 26px; }
.paywall-slim-sub { font-size: 14px; color: #8B7355; margin-top: 4px; }
.paywall-price { font-family: 'Frank Ruhl Libre', serif; font-size: 36px; font-weight: 700; color: #5C3D2E; margin: 8px 0 18px; position: relative; }
.paywall-price small { font-size: 16px; opacity: 0.7; margin-right: 4px; }
.paywall-features { display: grid; grid-template-columns: 1fr; gap: 8px; max-width: 380px; margin: 16px auto 22px; text-align: right; position: relative; }
.paywall-feature { display: flex; align-items: center; gap: 10px; font-size: 14px; color: #5C3D2E; padding: 10px 14px; background: rgba(255,255,255,0.6); border-radius: 10px; border: 1px solid rgba(196,168,130,0.3); }
.paywall-feature::before { content: '✓'; color: #A0704A; font-weight: 700; flex-shrink: 0; }
.paywall-fine { font-size: 13px; color: #8B7355; margin-top: 28px; line-height: 1.6; position: relative; }
.paywall-fine a { color: #A0704A; cursor: pointer; text-decoration: underline; font-weight: 500; }
.paywall-fine a:hover { color: #5C3D2E; }
.paywall-reassure { font-size: 13px; color: #8B7355; margin: 14px auto 0; max-width: 380px; line-height: 1.7; position: relative; }
.paywall-anchor { font-size: 13px; color: #5C3D2E; background: rgba(212,135,90,0.09); border: 1px solid rgba(196,168,130,0.35); border-radius: 12px; padding: 10px 16px; margin: 4px auto 16px; max-width: 430px; line-height: 1.7; position: relative; }
.paywall-promise-title { font-family: 'Frank Ruhl Libre', serif; font-size: 18px; font-weight: 700; color: #5C3D2E; margin: 32px 0 2px; position: relative; }
.paywall-quotes { display: grid; grid-template-columns: 1fr; gap: 10px; max-width: 420px; margin: 18px auto 6px; position: relative; }
.paywall-quote { background: rgba(255,255,255,0.75); border: 1px solid rgba(196,168,130,0.35); border-radius: 14px; padding: 14px 18px; font-size: 14px; line-height: 1.7; color: #5C3D2E; text-align: right; }
.paywall-quote-name { display: block; margin-top: 6px; font-size: 12px; color: #8B7355; font-weight: 600; }
.paywall-trust { display: flex; flex-wrap: wrap; justify-content: center; gap: 6px 14px; font-size: 12.5px; color: #5C3D2E; margin: 14px auto 0; max-width: 460px; line-height: 1.6; position: relative; }
.paywall-trust span::before { content: '✓ '; color: #A0704A; font-weight: 700; }
.paywall-whatsapp { display: inline-flex; align-items: center; gap: 8px; background: #fff; color: #1B8755; border: 1.5px solid rgba(27,135,85,0.45); border-radius: 50px; padding: 9px 18px; font-family: 'Heebo', sans-serif; font-size: 14px; font-weight: 600; cursor: pointer; text-decoration: none; margin-top: 14px; transition: background .15s, transform .15s; position: relative; }
.paywall-whatsapp:hover { background: rgba(27,135,85,0.07); transform: translateY(-1px); }
.paywall-grow { display: block; width: 100%; max-width: 340px; margin: 12px auto 0; background: #fff; color: #5C3D2E; border: 1.5px solid rgba(160,112,74,0.55); border-radius: 50px; padding: 13px 24px; font-family: 'Heebo', sans-serif; font-size: 15.5px; font-weight: 700; cursor: pointer; text-decoration: none; text-align: center; transition: background .15s, transform .15s; position: relative; }
.paywall-grow:hover { background: rgba(160,112,74,0.07); transform: translateY(-1px); }
.paywall-grow[aria-disabled="true"] { opacity: 0.5; cursor: not-allowed; pointer-events: none; }
.paywall-grow-note { font-size: 12px; color: #8B7355; margin: 8px auto 0; max-width: 380px; line-height: 1.6; position: relative; }
.paywall-email-row { display: flex; gap: 8px; flex-wrap: wrap; max-width: 420px; margin: 0 auto; position: relative; }
.paywall-email-input { flex: 1 1 200px; border: 1px solid #D9C8B0; border-radius: 12px; padding: 12px 14px; font-family: 'Heebo', sans-serif; font-size: 15px; color: #2D1B10; background: #fff; direction: ltr; text-align: left; position: relative; }
.paywall-email-input:focus { outline: 2px solid rgba(160,112,74,0.4); }
.paywall-email-title { font-family: 'Frank Ruhl Libre', serif; font-size: 19px; font-weight: 700; color: #5C3D2E; margin: 4px 0 10px; position: relative; }
.paywall-email-note { font-size: 12.5px; color: #8B7355; margin: 10px auto 0; max-width: 400px; line-height: 1.6; position: relative; }
.paywall-heard { max-width: 420px; margin: 14px auto 0; position: relative; text-align: right; }
.paywall-heard-q { font-size: 13.5px; color: #5C3D2E; font-weight: 600; margin-bottom: 6px; }
.paywall-heard-row { display: flex; flex-wrap: wrap; gap: 6px; }
.paywall-heard-opt { background: #fff; border: 1px solid #D9C8B0; border-radius: 50px; padding: 7px 13px; font-family: 'Heebo', sans-serif; font-size: 13px; color: #5C3D2E; cursor: pointer; }
.paywall-heard-opt.on { background: #A0704A; border-color: #A0704A; color: #fff; }
.paywall-gift-banner { display: block; width: 100%; box-sizing: border-box; margin: 22px auto 0; max-width: 460px; padding: 18px 20px 20px; border-radius: 18px; background: linear-gradient(135deg, #1E2A44, #34507A); color: #fff; text-align: center; cursor: pointer; border: 2px solid #F0C27B; box-shadow: 0 10px 30px rgba(30,42,68,0.28); position: relative; transition: transform .15s; }
.paywall-gift-banner:hover { transform: translateY(-2px); }
.paywall-gift-banner-kicker { font-size: 13px; letter-spacing: 1px; color: #F0C27B; font-weight: 700; margin-bottom: 4px; }
.paywall-gift-banner-title { font-family: 'Frank Ruhl Libre', serif; font-size: 26px; font-weight: 700; line-height: 1.25; }
.paywall-gift-banner-sub { font-size: 14.5px; opacity: .95; margin: 6px 0 12px; line-height: 1.6; }
.paywall-gift-banner-cta { display: inline-block; background: #F0C27B; color: #5C1F2A; font-weight: 700; padding: 11px 26px; border-radius: 14px; font-size: 16px; }
@media (max-width: 600px) { .paywall-gift-banner-title { font-size: 23px; } }
.paywall-gift-box { background: #FBF3E6; border: 1px solid #E8DCC8; border-radius: 16px; padding: 18px 16px 14px; margin: 14px auto 0; max-width: 440px; text-align: right; position: relative; }
.paywall-gift-box .paywall-email-input { width: 100%; box-sizing: border-box; margin-top: 8px; }
.paywall-gift-box .paywall-email-input.rtl { direction: rtl; text-align: right; }
.paywall-gift-box textarea.paywall-email-input { resize: vertical; min-height: 64px; }
.paywall-gift-label { font-size: 13px; color: #5C3D2E; font-weight: 600; margin-top: 10px; display: block; }
.paywall-gift-sub { font-size: 12.5px; color: #8B7355; line-height: 1.6; margin: 2px 0 0; }
.paywall-email-ok { font-size: 13.5px; line-height: 1.7; padding: 10px 16px; border-radius: 10px; margin: 14px auto 4px; max-width: 420px; background: #E8F4EC; color: #2E7D32; border-right: 3px solid #4CAF50; text-align: right; position: relative; }
.paywall-email-err { font-size: 13.5px; line-height: 1.7; padding: 10px 16px; border-radius: 10px; margin: 12px auto 0; max-width: 420px; background: #FFF0F0; color: #C62828; border-right: 3px solid #E53935; text-align: right; position: relative; }
.paywall-paypal-hint { font-size: 12.5px; color: #8B7355; margin-top: 12px; line-height: 1.6; position: relative; }
.paywall-warning { font-size: 12px; color: #B8860B; background: rgba(255,235,156,0.5); border: 1px dashed #B8860B; border-radius: 8px; padding: 8px 12px; margin: 12px auto 0; max-width: 360px; position: relative; }
@media (max-width: 600px) { .paywall-card { padding: 28px 18px; } .paywall-title { font-size: 22px; } .paywall-lead { font-size: 15px; } }
`;

// Reader testimonials for the paywall. Filled from the WhatsApp reviewer
// wave as approved quotes arrive (name + age/city per the person's consent).
// Empty array = the section simply doesn't render.
const TESTIMONIALS: { quote: string; name: string }[] = [];

// Human ordering channel for the 55+ audience (trust package, 5.8): the
// WhatsApp button renders only once Shlomo provides the number to show.
// Format: international digits only, e.g. "9725XXXXXXXX".
const WHATSAPP_NUMBER = "972544562084"; // 054-4562084 (Shlomo, 5.8) — also voice calls

// Grow (Meshulam) permanent payment page — Bit / any Israeli card, ILS,
// VAT invoice included. Created 10.8.2026 in Shlomo's Grow account (10531312),
// link name "שאלת האריה - סדנה מלאה 89". Access is granted MANUALLY from the
// admin purchases screen until the Grow webhook flow ships (phase B), which
// is why the caption under the button promises "within a short time" and not
// "immediate". Managed at grow.website → Payment Links.
const GROW_PAYMENT_URL =
  "https://pay.grow.link/MTA0MzEz~e20e2544cb366b3714ecad8b0136f20a-MzgyMDI3OA";

type PaywallGateProps = {
  chapter: number;
  chapterTitle: string;
  onBackToChapter1: () => void;
};

export function PaywallGate({
  chapter,
  chapterTitle,
  onBackToChapter1,
  // "direct" (variant-B landing): buy-first framing for visitors who
  // haven't tasted a chapter. Shlomo 29.8: the refund stays out of the
  // marketing copy — legal pages only.
  variant = "chapter",
  // /gift landing: open straight on the gift form.
  initialGift = false,
}: PaywallGateProps) {
  const [authOpen, setAuthOpen] = useState(false);
  const [buying, setBuying] = useState(false);
  // Email-first checkout for anonymous visitors (Shlomo, 10.8: "כמו שזה
  // עכשיו זה לא מוצלח" — a buyer with Bit in hand must not be sent to a
  // separate registration step). One email field folds sign-up into the
  // purchase: signInWithOtp creates the account on the spot (so the Grow
  // webhook can match payerEmail) and mails the magic link, then both
  // payment buttons appear. Whoever types an email and doesn't pay is a
  // lead — same as LeadCaptureCard.
  const [guestEmail, setGuestEmail] = useState("");
  const [guestState, setGuestState] = useState<"idle" | "sending" | "ready" | "error">("idle");
  const [guestErr, setGuestErr] = useState("");
  const { user, email } = useAuth();
  const isSignedIn = !!user;

  // "איך שמעת עלינו?" (15.9): utm tags only see ads. One tap next to the
  // email field, stored on the profile (or the gift order) - the only way
  // to measure word of mouth once the organic track starts.
  const HEARD_OPTIONS = ["פייסבוק / אינסטגרם", "חבר/ה או משפחה", "לינקדאין", "טיקטוק / יוטיוב", "אחר"];
  const [heardFrom, setHeardFrom] = useState("");
  const heardRow = (
    <div className="paywall-heard">
      <div className="paywall-heard-q">איך שמעת עלינו? (לחיצה אחת, עוזר לנו מאוד)</div>
      <div className="paywall-heard-row">
        {HEARD_OPTIONS.map((o) => (
          <button
            key={o}
            type="button"
            className={"paywall-heard-opt" + (heardFrom === o ? " on" : "")}
            onClick={() => {
              const next = heardFrom === o ? "" : o;
              setHeardFrom(next);
              // Signed-in buyers have no "continue" step - stamp right away.
              if (next && isSignedIn && email) {
                supabase.rpc("set_heard_from", { _email: email, _choice: next }).then(() => {}, () => {});
              }
            }}
          >
            {o}
          </button>
        ))}
      </div>
    </div>
  );

  // After the payment click (14.9, Ilana's case): Grow opens in a second tab
  // and never returns to us, so the buyer comes back to THIS tab and still
  // sees the offer screen. A guest has no browser session (signInWithOtp
  // only mails the link), so she can't be let in silently - the screen has
  // to say, in three short moves, that the door is the email. A signed-in
  // buyer can be let in: poll user_has_access while the tab is visible and
  // reload the moment the webhook grants the license.
  const [payClicked, setPayClicked] = useState(() => {
    try {
      const t = Number(window.sessionStorage.getItem("ei_pay_clicked") || 0);
      return t > 0 && Date.now() - t < 2 * 60 * 60 * 1000;
    } catch {
      return false;
    }
  });
  const [payWatch, setPayWatch] = useState<"idle" | "granted">("idle");
  const [resendState, setResendState] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const onPayClick = () => {
    trackInitiateCheckout();
    setPayClicked(true);
    try {
      window.sessionStorage.setItem("ei_pay_clicked", String(Date.now()));
    } catch { /* private mode */ }
  };
  useEffect(() => {
    if (!payClicked || !user || payWatch === "granted") return;
    let stopped = false;
    let inFlight = false;
    const startedAt = Date.now();
    const check = async () => {
      if (stopped || inFlight || document.visibilityState === "hidden") return;
      if (Date.now() - startedAt > 10 * 60 * 1000) return;
      inFlight = true;
      try {
        const { data } = await supabase.rpc("user_has_access", { uid: user.id });
        if (data && !stopped) {
          setPayWatch("granted");
          try {
            window.sessionStorage.removeItem("ei_pay_clicked");
            window.sessionStorage.setItem("just_purchased", "1");
          } catch { /* private mode */ }
          window.setTimeout(() => window.location.reload(), 1500);
        }
      } finally {
        inFlight = false;
      }
    };
    const id = window.setInterval(check, 5000);
    document.addEventListener("visibilitychange", check);
    window.addEventListener("focus", check);
    check();
    return () => {
      stopped = true;
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", check);
      window.removeEventListener("focus", check);
    };
  }, [payClicked, user, payWatch]);
  const resendLoginLink = async () => {
    const target = (email || guestEmail || "").trim().toLowerCase();
    if (!target) {
      setAuthOpen(true);
      return;
    }
    setResendState("sending");
    const { error } = await supabase.auth.signInWithOtp({
      email: target,
      options: { emailRedirectTo: window.location.origin },
    });
    setResendState(error && !/rate/i.test(error.message || "") ? "error" : "sent");
  };
  // Gift mode (10.9, "מתנה לחג"): recipient details are stored on our side
  // (create_gift_order) BEFORE payment; the Grow/Lemon webhook then matches
  // the payer's email to the pending order and mails the recipient a
  // personal /r/<token> link. The buyer needs no account and no OTP.
  const [giftMode, setGiftMode] = useState(!!initialGift);
  const [gift, setGift] = useState({ recipientName: "", recipientEmail: "", note: "", buyerName: "", buyerEmail: "" });
  const [giftState, setGiftState] = useState<"idle" | "sending" | "ready" | "error">("idle");
  const [giftErr, setGiftErr] = useState("");
  const buyerEmail = giftMode && giftState === "ready"
    ? gift.buyerEmail
    : email || guestEmail.trim();

  // Micro-survey (29.8): after ~25s of hesitation on the offer screen,
  // ask the one question analytics can't answer — "מה עוצר אותך כרגע?".
  // Shown once per browser; answers go to paywall_feedback (insert-only).
  const [survey, setSurvey] = useState<"hidden" | "open" | "thanks" | "done">("hidden");
  const [surveyChoice, setSurveyChoice] = useState("");
  const [surveyText, setSurveyText] = useState("");
  useEffect(() => {
    try {
      if (window.localStorage.getItem("paywall_survey_done")) return;
    } catch { /* private mode */ }
    const t = window.setTimeout(() => setSurvey("open"), 25000);
    return () => window.clearTimeout(t);
  }, []);
  const surveyUtm = () => {
    try {
      const raw = window.localStorage.getItem("acq_utm_v1");
      if (!raw) return {};
      const a = JSON.parse(raw);
      return { utm_source: a.source || null, utm_campaign: a.campaign || null };
    } catch {
      return {};
    }
  };
  const sendSurveyChoice = async (choice) => {
    setSurveyChoice(choice);
    setSurvey("thanks");
    try {
      window.localStorage.setItem("paywall_survey_done", "1");
    } catch { /* private mode */ }
    await supabase.from("paywall_feedback").insert({
      choice,
      user_id: user?.id ?? null,
      ...surveyUtm(),
    });
  };
  const sendSurveyText = async () => {
    const clean = surveyText.trim();
    setSurvey("done");
    if (!clean) return;
    await supabase.from("paywall_feedback").insert({
      choice: `פירוט (${surveyChoice})`,
      free_text: clean.slice(0, 1000),
      user_id: user?.id ?? null,
      ...surveyUtm(),
    });
  };

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const onGuestContinue = async () => {
    const clean = guestEmail.trim().toLowerCase();
    if (!EMAIL_RE.test(clean)) {
      setGuestErr("כתובת המייל לא נראית תקינה - בדקו אותה ונסו שוב.");
      setGuestState("error");
      return;
    }
    setGuestState("sending");
    trackLead();
    const { error } = await supabase.auth.signInWithOtp({
      email: clean,
      options: { emailRedirectTo: window.location.origin },
    });
    // A rate-limit error means the link was already sent moments ago — the
    // account exists, so payment matching works; let the buyer proceed.
    if (error && !/rate/i.test(error.message || "")) {
      setGuestErr("משהו השתבש בשליחה. נסו שוב עוד רגע.");
      setGuestState("error");
      return;
    }
    setGuestEmail(clean);
    setGuestState("ready");
    if (heardFrom) {
      try {
        await supabase.rpc("set_heard_from", { _email: clean, _choice: heardFrom });
      } catch { /* best-effort */ }
    }
    // Stamp the first-touch source on the freshly created account now:
    // a Grow buyer may never open the magic link, so flushAttribution()
    // (which needs a signed-in session) would leave utm_source null.
    try {
      const raw = window.localStorage.getItem("acq_utm_v1");
      if (raw) {
        const a = JSON.parse(raw);
        await supabase.rpc("claim_attribution_by_email", {
          _email: clean,
          _source: a.source,
          _medium: a.medium || null,
          _campaign: a.campaign || null,
          _landed_at: a.landed_at || null,
        });
      }
    } catch { /* best-effort */ }
    // Link this account to the taste-film session (13.9): did the buyer watch?
    try {
      const vs = window.localStorage.getItem("taste_video_session");
      if (vs) await supabase.rpc("claim_video_session", { _email: clean, _session: vs });
    } catch { /* best-effort */ }
  };

  const onGiftContinue = async () => {
    const be = (gift.buyerEmail || email || "").trim().toLowerCase();
    const re = gift.recipientEmail.trim().toLowerCase();
    if (!gift.recipientName.trim()) {
      setGiftErr("איך קוראים למי שמקבל/ת את המתנה?");
      setGiftState("error");
      return;
    }
    if (!EMAIL_RE.test(re)) {
      setGiftErr("כתובת המייל של מקבל/ת המתנה לא נראית תקינה.");
      setGiftState("error");
      return;
    }
    if (!EMAIL_RE.test(be)) {
      setGiftErr("כתובת המייל שלך לא נראית תקינה - איתה נזהה את התשלום.");
      setGiftState("error");
      return;
    }
    if (re === be) {
      setGiftErr("המייל של המקבל/ת זהה לשלך - לרכישה לעצמך אפשר לחזור למסלול הרגיל.");
      setGiftState("error");
      return;
    }
    setGiftState("sending");
    trackLead();
    const { data: giftId, error } = await supabase.rpc("create_gift_order", {
      _buyer_email: be,
      _buyer_name: gift.buyerName.trim(),
      _recipient_name: gift.recipientName.trim(),
      _recipient_email: re,
      _note: gift.note.trim(),
    });
    if (error) {
      setGiftErr(/too many/.test(error.message || "") ? "יותר מדי ניסיונות - נסו שוב בעוד שעה." : "משהו השתבש. נסו שוב עוד רגע.");
      setGiftState("error");
      return;
    }
    setGift((g) => ({ ...g, buyerEmail: be, recipientEmail: re }));
    setGiftState("ready");
    if (heardFrom && giftId) {
      try {
        await supabase.rpc("set_gift_heard_from", { _gift_id: giftId, _choice: heardFrom });
      } catch { /* best-effort */ }
    }
  };

  const onBuy = async () => {
    if (buying) return;
    setBuying(true);
    trackInitiateCheckout();
    try {
      const url = await buildCheckoutUrl(buyerEmail);
      if (!url) {
        alert("המוצר בלימון סקוויזי עדיין לא הוגדר במלואו. נא להוסיף Variant ID ב‑src/lib/lemonConfig.ts");
        return;
      }
      openLemonCheckout(url);
    } finally {
      setBuying(false);
    }
  };

  // Consent is implied by the payment click (one line under the button,
  // with the same four links) instead of a gating checkbox: the 23.8 funnel
  // audit found the legal paragraph sitting BEFORE the email field on the
  // first mobile screen, and 8 of 11 sign-ups vanishing right there.
  const consentLine = (
    <p className="paywall-consent-line">
      בלחיצה על "לתשלום" אני מאשר/ת את{" "}
      <a href="/legal/terms.html" target="_blank" rel="noreferrer">תנאי השימוש</a>,{" "}
      <a href="/legal/privacy.html" target="_blank" rel="noreferrer">הפרטיות</a>,{" "}
      <a href="/legal/refund.html" target="_blank" rel="noreferrer">ההחזרים</a>{" "}
      ו<a href="/legal/accessibility.html" target="_blank" rel="noreferrer">הנגישות</a>
      {" "}· לגיל 18+
    </p>
  );

  // One big door, not two: Grow takes Bit AND every Israeli card, in Hebrew,
  // with an invoice. Lemon Squeezy (English checkout, foreign merchant) stays
  // as a small text link for cards from abroad.
  const payButtons = (
    <>
      <a
        className="paywall-pay"
        href={GROW_PAYMENT_URL}
        target="_blank"
        rel="noreferrer"
        onClick={onPayClick}
      >
        לתשלום - ביט או כרטיס אשראי ←
      </a>
      {/* 15.9: a gift buyer reported "דף התשלום לא נפתח". The button opens
          Grow in a new tab, which some in-app browsers and popup blockers
          swallow silently. Same-tab fallback, shown only after the click. */}
      {payClicked && (
        <p className="paywall-pay-note" style={{ marginTop: 8 }}>
          דף התשלום לא נפתח?{" "}
          <a href={GROW_PAYMENT_URL} style={{ color: "#A0704A", fontWeight: 700, textDecoration: "underline" }}>
            לחצו כאן לפתיחה בחלון הזה
          </a>
        </p>
      )}
      {payClicked && !giftMode && (
        <div className="paywall-email-ok" style={{ marginTop: 12 }}>
          {payWatch === "granted" ? (
            <><strong>התשלום התקבל.</strong> פותחים לך את הסדנה...</>
          ) : isSignedIn ? (
            <>
              <strong>התשלום נפתח בחלון נפרד.</strong> כשהוא מסתיים, הסדנה נפתחת
              כאן לבד תוך דקה. אפשר להשאיר את הדף הזה פתוח.
            </>
          ) : (
            <>
              <strong>שילמת? הגישה נפתחת תוך דקה.</strong> כדי להיכנס לסדנה:
              <br />
              1. פותחים את המייל ששלחנו ל-
              <strong style={{ direction: "ltr", unicodeBidi: "embed" }}>{buyerEmail}</strong>
              {" "}(מ-eiforall.com, הנושא "קישור הכניסה שלך").
              <br />
              2. לוחצים על הכפתור הגדול שבתוך המייל.
              <br />
              3. הספר נפתח. בלי סיסמה, בלי תשלום נוסף.
              <br />
              <span style={{ display: "inline-block", marginTop: 6 }}>
                {resendState === "sent" ? (
                  <>נשלח שוב. המייל יכול לקחת דקה.</>
                ) : resendState === "error" ? (
                  <>לא הצלחנו לשלוח. כתבו לנו בוואטסאפ 054-4562084.</>
                ) : (
                  <>
                    המייל לא הגיע?{" "}
                    <a
                      onClick={resendLoginLink}
                      style={{ color: "#A0704A", fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}
                    >
                      {resendState === "sending" ? "שולח..." : "שלחו לי שוב את המייל"}
                    </a>
                  </>
                )}
              </span>
            </>
          )}
        </div>
      )}
      <p className="paywall-pay-note">
        בדף התשלום רשמו את אותה כתובת מייל
        {buyerEmail ? <> (<strong style={{ direction: "ltr", unicodeBidi: "embed" }}>{buyerEmail}</strong>)</> : null}
        {giftMode && giftState === "ready"
          ? <> - ותוך דקה {gift.recipientName} מקבל/ת מייל עם הקישור האישי, ואת/ה עותק.</>
          : <> - והגישה נפתחת אוטומטית תוך דקה.</>}
      </p>
      {consentLine}
      {LEMON_VARIANT_ID && (
        <p className="paywall-fine" style={{ marginTop: 10 }}>
          כרטיס מחו״ל או PayPal?{" "}
          <a onClick={onBuy}>{buying ? "פותח..." : "תשלום בינלאומי"}</a>
        </p>
      )}
    </>
  );

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="paywall-wrap">
        <div className="paywall-card">
          {/* Offer screen v2 (23.8 audit): promise → proof → what you get →
              price → one email field → ONE payment door. The heart (drawn by
              Shlomo's son) stays; the "chapter N" framing and the legal
              paragraph-before-the-ask are gone. */}
          {/* "slim" (sales page v2, 21.10): the page above already carried the
              promise, the author and the video - here only the door. */}
          {variant === "slim" && (
            <div className="paywall-slim-head">
              <div className="paywall-slim-price">כל הסדנה, 12 פרקים: <strong>89 ₪</strong></div>
              <div className="paywall-slim-sub">פעם אחת, לתמיד. קישור כניסה למייל, בלי סיסמה.</div>
            </div>
          )}
          {variant !== "slim" && (<>
          <img
            className="paywall-hero paywall-hero-square paywall-hero-sm"
            src="/heart-by-noam.webp"
            alt="לב מצויר מלא במילים של רגשות"
          />
          <div className="paywall-chip">הסדנה המלאה · 12 מפגשים</div>
          <h2 className="paywall-title">
            פחות התפרצויות. שינה עמוקה יותר. בית שקט יותר.
          </h2>
          <p className="paywall-lead">
            {variant === "direct" ? (
              <>
                12 מפגשים שהופכים שאלה בת שלוש מילים להרגל - בקולי, בקצב
                שלך, לתמיד. מתחילים עכשיו - עוד היום השאלה כבר איתך.
              </>
            ) : (
              <>
                המפגש הראשון היה טעימה. 11 המפגשים הבאים לוקחים את השאלה בת
                שלוש המילים והופכים אותה להרגל - בקולי, בקצב שלך, לתמיד.
              </>
            )}
          </p>

          <div className="paywall-quotes">
            <div className="paywall-quote">
              „זה כל כך פשוט וכל כך עובד - שזה מטורף."
              <span className="paywall-quote-name">— ניב, משתתף סדנה</span>
            </div>
            <div className="paywall-quote">
              „שמעתי, לא האמנתי - עד שניסיתי. ומאז זה כבר באוטומט."
              <span className="paywall-quote-name">— אלונה, משתתפת סדנה</span>
            </div>
            <div className="paywall-quote">
              „שינוי כזה צפוי היה להיות ארוך ומורכב. אבל לא כאן - זה אשכרה פטנט רגשי."
              <span className="paywall-quote-name">— ירון, משתתף סדנה</span>
            </div>
          </div>

          <div className="paywall-features">
            <div className="paywall-feature">12 מפגשים, מוקלטים בקול המנחה, עם תרגילים אישיים - בקצב שלך</div>
            <div className="paywall-feature">כל מה שתכתבי נשמר לך - קובץ שמלווה אותך בשנים הבאות</div>
            <div className="paywall-feature">גישה לתמיד, לחזור למפגשים שוב ושוב</div>
          </div>

          <div className="paywall-price">
            <small>₪</small>89
          </div>
          <p className="paywall-anchor">
            20 שנה אני מעביר את הסדנה הזו בארגונים - אל על, אגד, צה״ל ומשרדי
            ממשלה. קורס חי כזה עולה היום 3,000-4,000 ₪.
            <br />
            <strong>כאן: כל הסדנה, 89 ₪, פעם אחת - לתמיד.</strong>
          </p>
          </>)}

          {giftMode && giftState !== "ready" && (
            <div className="paywall-gift-box">
              <div className="paywall-email-title" style={{ margin: 0 }}>🎁 סדנה במתנה</div>
              <p className="paywall-gift-sub">
                ממלאים למי, משלמים - ומקבל/ת המתנה מקבל/ת מייל אישי עם קישור לסדנה. בלי סיסמאות, בלי הרשמה מראש.
              </p>
              <label className="paywall-gift-label">
                למי המתנה? (שם)
                <input className="paywall-email-input rtl" type="text" placeholder="למשל: רותי" value={gift.recipientName}
                  onChange={(e) => setGift({ ...gift, recipientName: e.target.value })} />
              </label>
              <label className="paywall-gift-label">
                המייל של מקבל/ת המתנה
                <input className="paywall-email-input" type="email" inputMode="email" placeholder="their@email.com" value={gift.recipientEmail}
                  onChange={(e) => setGift({ ...gift, recipientEmail: e.target.value })} />
              </label>
              <label className="paywall-gift-label">
                כמה מילים ממך (לא חובה)
                <textarea className="paywall-email-input rtl" rows={2} maxLength={600} placeholder="שנה טובה! חשבתי עלייך כשראיתי את זה…" value={gift.note}
                  onChange={(e) => setGift({ ...gift, note: e.target.value })} />
              </label>
              <label className="paywall-gift-label">
                השם שלך (יופיע במייל למקבל/ת)
                <input className="paywall-email-input rtl" type="text" placeholder="השם שלך" value={gift.buyerName}
                  onChange={(e) => setGift({ ...gift, buyerName: e.target.value })} />
              </label>
              {!email && (
                <label className="paywall-gift-label">
                  המייל שלך (איתו נזהה את התשלום)
                  <input className="paywall-email-input" type="email" inputMode="email" autoComplete="email" placeholder="your@email.com" value={gift.buyerEmail}
                    onChange={(e) => setGift({ ...gift, buyerEmail: e.target.value })} />
                </label>
              )}
              {heardRow}
              {giftState === "error" && <div className="paywall-email-err">{giftErr}</div>}
              <div style={{ textAlign: "center", marginTop: 14 }}>
                <button className="paywall-cta" style={{ padding: "12px 22px", fontSize: 15 }} onClick={onGiftContinue} disabled={giftState === "sending"}>
                  {giftState === "sending" ? "רגע..." : "המשך לתשלום ←"}
                </button>
              </div>
              <p className="paywall-fine" style={{ marginTop: 12, textAlign: "center" }}>
                <a onClick={() => { setGiftMode(false); setGiftState("idle"); }}>בעצם, לרכישה לעצמי</a>
              </p>
            </div>
          )}

          {giftMode && giftState === "ready" && (
            <>
              <div className="paywall-email-ok">
                <strong>מצוין.</strong> המתנה ל{gift.recipientName} מוכנה - נשאר רק לשלם:
              </div>
              {payButtons}
            </>
          )}

          {!giftMode && !isSignedIn && guestState !== "ready" && (
            <>
              <div className="paywall-email-title">לאן לפתוח לך את הגישה?</div>
              <div className="paywall-email-row">
                <input
                  className="paywall-email-input"
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  placeholder="your@email.com"
                  value={guestEmail}
                  onChange={(e) => setGuestEmail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") onGuestContinue();
                  }}
                  aria-label="כתובת מייל לפתיחת הגישה"
                />
                <button
                  className="paywall-cta"
                  style={{ padding: "12px 22px", fontSize: 15 }}
                  onClick={onGuestContinue}
                  disabled={guestState === "sending"}
                >
                  {guestState === "sending" ? "רגע..." : "המשך לתשלום ←"}
                </button>
              </div>
              {guestState === "error" && (
                <div className="paywall-email-err">{guestErr}</div>
              )}
              <p className="paywall-email-note">
                הגישה לסדנה נפתחת לכתובת הזו. משלמים בשלב הבא.
              </p>
              {heardRow}
              {/* 14.9: a buyer who paid in Grow and came back in another
                  browser lands here signed out. Say it plainly. */}
              {payClicked && (
                <div className="paywall-email-ok" style={{ marginTop: 14 }}>
                  <strong>שילמת כבר? הגישה שלך פתוחה.</strong> כדי להיכנס, פותחים את
                  המייל ששלחנו לך מ-eiforall.com ולוחצים על הכפתור שבתוכו.
                  {" "}לא הגיע?{" "}
                  <a
                    onClick={() => setAuthOpen(true)}
                    style={{ color: "#A0704A", fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}
                  >
                    שלחו לי שוב
                  </a>
                </div>
              )}
              <p className="paywall-fine" style={{ marginTop: 14, fontSize: 14 }}>
                כבר שילמת או נרשמת בעבר?{" "}
                <a onClick={() => setAuthOpen(true)} style={{ fontWeight: 700 }}>
                  כניסה עם המייל שלך ←
                </a>
              </p>
            </>
          )}

          {!giftMode && !isSignedIn && guestState === "ready" && (
            <>
              <div className="paywall-email-ok">
                <strong>מצוין.</strong> לחיצה אחת - ואת בפנים:
              </div>
              {payButtons}
            </>
          )}

          {!giftMode && isSignedIn && (
            <>
              {heardRow}
              {payButtons}
            </>
          )}

          {!giftMode && (
            <div
              className="paywall-gift-banner"
              role="button"
              tabIndex={0}
              onClick={() => { setGiftMode(true); setGuestState("idle"); }}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { setGiftMode(true); setGuestState("idle"); } }}
            >
              <div className="paywall-gift-banner-kicker">אין מתנה נפלאה יותר לחבר באמת קרוב</div>
              <div className="paywall-gift-banner-title">🎁 פיתוח אינטליגנציה רגשית זו מתנה לחיים</div>
              <div className="paywall-gift-banner-sub">
                לבן/בת הזוג, לילדים הבוגרים, לחברה שתמיד רצתה. 89 ₪, נשלח במייל אישי בשמך - תוך דקה.
              </div>
              <span className="paywall-gift-banner-cta">לרכישה כמתנה ←</span>
            </div>
          )}

          <div className="paywall-trust">
            <span>תשלום מאובטח בביט או באשראי</span>
            <span>חשבונית מס לכל רכישה</span>
            <span>גישה מיידית אחרי התשלום</span>
          </div>
          {survey === "open" && (
            <div className="paywall-survey">
              <div className="paywall-survey-q">אפשר לשאול? מה עוצר אותך כרגע?</div>
              <div className="paywall-survey-row">
                <button className="paywall-survey-opt" onClick={() => sendSurveyChoice("המחיר")}>המחיר</button>
                <button className="paywall-survey-opt" onClick={() => sendSurveyChoice("לא בטוחה שזה בשבילי")}>לא בטוחה שזה בשבילי</button>
                <button className="paywall-survey-opt" onClick={() => sendSurveyChoice("אחזור אחר כך")}>אחזור אחר כך</button>
                <button className="paywall-survey-opt" onClick={() => sendSurveyChoice("משהו אחר")}>משהו אחר</button>
              </div>
            </div>
          )}
          {survey === "thanks" && (
            <div className="paywall-survey">
              <div className="paywall-survey-thanks">תודה! 🙏 זה עוזר לנו מאוד.</div>
              <textarea
                className="paywall-survey-input"
                rows={2}
                placeholder="רוצה לפרט במילה? (לא חובה)"
                value={surveyText}
                onChange={(e) => setSurveyText(e.target.value)}
              />
              <button className="paywall-survey-send" onClick={sendSurveyText}>
                שליחה
              </button>
            </div>
          )}
          {WHATSAPP_NUMBER && (
            <a
              className="paywall-whatsapp"
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
                "שלום שלמה, אשמח להזמין את הסדנה «שאלת האריה» (89 ₪)"
              )}`}
              target="_blank"
              rel="noreferrer"
            >
              💬 מעדיפים להזמין בוואטסאפ או בשיחה? 054-4562084
            </a>
          )}
          <p className="paywall-fine" style={{ marginTop: 22 }}>
            {/* The free-chapter escape stays only where the ads promised it
                (variant "chapter"); direct-landing visitors were promised
                nothing free (Shlomo 30.8, LinkedIn traffic). */}
            {variant === "chapter" && (
              <>
                רוצים לחזור לטעימה? <a onClick={onBackToChapter1}>חזרה למפגש 1</a>
                {" · "}
              </>
            )}
            שאלה לפני רכישה? <a href="/contact">צרו קשר</a>
          </p>
        </div>
      </div>
      {authOpen && <AuthModal onClose={() => setAuthOpen(false)} />}
    </>
  );
}
